module.exports = __webpack_public_path__ + "img/user-04.3ac7ddd3.jpg";